import React from "react";
import StemcafeLogoGrey from "../assets/svg/stemcafe-logo-grey.svg";
import TwitterIcon from "../assets/svg/twitter.svg";
import InstagramIcon from "../assets/svg/instagram.svg";
import YoutubeIcon from "../assets/svg/youtube.svg";

const Footer: React.FC = () => {
  return (
    <>
      <div className="footer-avatar"></div>
      <footer>
        <div className="container">
          <div className="logo-footer">
            <img src={StemcafeLogoGrey} alt="" />
          </div>
          <div className="social-links">
            <ul>
              <li>
                <a
                  href="https://twitter.com/STEM_Cafe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={TwitterIcon} alt="STEMCafe on Twitter" />
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/stem_cafe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={InstagramIcon} alt="STEMCafe on Instagram" />
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com/channel/UCCtRI-OFw-K3a7ydIdAvpCQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={YoutubeIcon} alt="STEMCafe on YouTube" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
